import React from "react";
import { Box } from "@mui/material";
import Tooltip from "../Tooltip";
import Chip from "./Chip";
import useTranslation from "../../hooks/useTranslation";

export interface ChipsProps {
  value?: string[];
  maxLength?: number;
};

const Chips = ({ value = [], maxLength }: ChipsProps) => {
  const items = maxLength ? value.slice(0, maxLength) : value;
  const extraItems = maxLength && value.length > maxLength ? value.slice(maxLength) : [];
  const { translate } = useTranslation("common");

  return (
    <Box className="flex gap-1 flex-wrap">
      {items.map(item => <Chip key={item} value={item} />)}

      {!!extraItems.length && (
        <Tooltip title={<Box sx={{ whiteSpace: 'pre-line' }}>{extraItems.join(",\n")}</Box>}>
          <Box>
            <Chip value={translate("chips.more", { count: extraItems.length })} variant="more" />
          </Box>
        </Tooltip>
      )}
    </Box>
  );
};

export default Chips;